import { HubspotFormLegalCheckboxFragmentFragment } from "@graphqlTypes"
import { generateConditionalClassName, oneLineHelpScout } from "@utils"
import React, { FC, useState } from "react"

import ValidationIcon from "../ValidationIcon/ValidationIcon"

import "./LegalConsentCheckbox.scss"

const LegalConsentCheckbox: FC<HubspotFormLegalCheckboxFragmentFragment & {
  hasMultipleOptions?: boolean,
  isCompact?: boolean,
  isDisabled?: boolean,
  isSubscription?: boolean,
  isInvalid?: boolean,
}> = ({
  hasMultipleOptions,
  isCompact,
  isDisabled,
  isInvalid,
  isSubscription,
  label,
  required,
  subscriptionTypeId,
}) => {
    if (!label || !subscriptionTypeId) return null

    const name = `legal--${subscriptionTypeId}`
    const [isChecked, setIsChecked] = useState<boolean>(false)

    return (
      <label
        className={generateConditionalClassName({
          "HubspotForm--LegalConsentCheckbox": true,
          "subscription-checkbox": !!isSubscription,
          "is-disabled": !!isDisabled,
        })}
      >
        <input
          checked={isChecked}
          className={generateConditionalClassName({
            "has-error" : !!isInvalid,
            "size--S": !!isCompact,
          })}
          disabled={isDisabled}
          name={name}
          onChange={() => setIsChecked(_isChecked => !_isChecked)}
          required={!!required}
          type="checkbox"
        />
        <input type="hidden" name={`${name}__TEXT`} value={label} />
        <div dangerouslySetInnerHTML={{ __html: oneLineHelpScout(label) }} />
        {isInvalid && (
          <ValidationIcon
            fieldName={name}
            message={
              hasMultipleOptions ?
                "Please select at least one option" :
                undefined
            }
            size="calc(var(--font-size--S) * var(--line-height--relaxed))"
          />
        )}
      </label>
    )
  }

export default LegalConsentCheckbox
